import { EnglishArabicDTO } from "bnsights-control-library"
export class PermissionSetModel
{
      Id:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      OrganizationID :number
      PermissionIDs :number[]
      SysName :string
      OrganizationName :EnglishArabicDTO=new EnglishArabicDTO();  
}
     